<template>
  <div class="schedular-import-values-table">
    <b-table
      striped
      hoverable
      :data="values"
      sticky-header
      scrollable
      :loading="loading"
    >
      <template slot-scope="props">
        <b-table-column field="activity_owner" label="Activity Owner">
          <b-tooltip
            type="is-dark"
            :label="props.row.activity_owner.name || 'N/A'"
            position="is-right"
          >
            {{ props.row.activity_owner.council_id }}
          </b-tooltip>
        </b-table-column>
        <b-table-column field="activity_code" label="Activity Code">
          <b-tooltip
            type="is-dark"
            :label="props.row.activity_code.name || 'N/A'"
          >
            {{ props.row.activity_code.code }}
          </b-tooltip>
        </b-table-column>
        <b-table-column field="asset_type" label="Asset Type">
          <b-tooltip type="is-dark" :label="props.row.asset_type.name || 'N/A'">
            {{ props.row.asset_type.code }}
          </b-tooltip>
        </b-table-column>
        <b-table-column field="rate_code" label="Rate Code">
          <b-tooltip
            type="is-dark"
            :label="props.row.rate_code.description || 'N/A'"
          >
            {{ props.row.rate_code.code }}
          </b-tooltip>
        </b-table-column>
        <b-table-column field="frequency" label="Frequency">
          {{ props.row.frequency }}
        </b-table-column>
      </template>

      <template slot="empty">
        <div class="content has-text-grey has-text-centered">
          <p>NO RECORDS FOUND</p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { MaintenanceTaskService } from "@/services/maintenanceTask.service";

export default {
  props: {
    contract: {
      type: Object,
    },
  },
  data: () => ({
    values: [],
    loading: false,
  }),
  methods: {
    async fetchValues() {
      this.values = [];
      try {
        this.loading = true;
        if (this.contract) {
          const values = await MaintenanceTaskService.listImportValues({
            contract_id: this.contract.id,
          }).then((response) => response.data);
          let rows = [];
          let i = 0;
          while (
            values.activity_codes[i] ||
            values.activity_owners[i] ||
            values.asset_types[i] ||
            values.rate_codes[i] ||
            values.frequencies[i]
          ) {
            rows.push({
              activity_owner: values.activity_owners[i] || "",
              activity_code: values.activity_codes[i] || "",
              asset_type: values.asset_types[i] || "",
              rate_code: values.rate_codes[i] || "",
              frequency: values.frequencies[i] || "",
            });
            i++;
          }
          this.values = rows;
        }
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Schedular/SchedularImportValuesTable.vue